import * as Yup from 'yup';
import moment from 'moment';

//const MAX_ID_STR = 9223372036854770; //9007199254740991

const validationSchema = Yup.object().shape({

    incident_id: Yup.number().min(0, 'ID cannot be less than 0')
    .max(9223372036854770, 'ID cannot be greater than 9223372036854770')
    .test('is-integer', 'ID must be an integer', value => {
      if (value === undefined || value === null || value === '') return true;
      return Number.isInteger(value);
    }),
    startscore_nr: Yup.number()
        .min(-50000, 'Score must be between -50000 and 50000')
        .max(50000, 'Score must be between -50000 and 50000')
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value)),
    endscore_nr: Yup.number()
        .min(-50000, 'Score must be between -50000 and 50000')
        .max(50000, 'Score must be between -50000 and 50000')
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value)),
    // The /incidents/filter endpoint only applies a date range when both bounds
    // are present — an end date on its own is ignored server-side — so require
    // the start date rather than letting the filter silently do nothing.
    startincident_dt: Yup.date().when('endincident_dt', {
      is: (endincident_dt) => !!endincident_dt,
      then: (schema) => schema.required('Start date is required when an end date is selected'),
      otherwise: (schema) => schema,
    }),

    endincident_dt: Yup.date().test('endincident_dt', 'End date must be greater than or equal to start date', function(value) {
  
      const { startincident_dt } = this.parent;
  
      if (startincident_dt) {
  
        return moment(value).isSameOrAfter(startincident_dt);
  
      } else {
  
        return true;
  
      }
  
    }),
  
  });

export default validationSchema